import { createTheme } from '@mui/material/styles';

// Tema Sisagri - Design inspirado no sisagri-fornecimento-mobile
const theme = createTheme({
  palette: {
    primary: {
      main: '#1a9e8f',
      light: '#d6f0ed',
      dark: '#0a7b6f',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#12b6aa',
      light: '#e0f7f5',
      dark: '#0e8f85',
      contrastText: '#ffffff',
    },
    error: {
      main: '#ff4d4d',
      light: '#ffe6e6',
      dark: '#cc3d3d',
    },
    warning: {
      main: '#ffb800',
      light: '#fff3cd',
      dark: '#cc9300',
    },
    success: {
      main: '#229466',
      light: '#d4edda',
      dark: '#1b7652',
    },
    info: {
      main: '#0084ff',
      light: '#cce5ff',
      dark: '#0069cc',
    },
    background: {
      default: '#f0f5f4',
      paper: '#ffffff',
    },
    text: {
      primary: '#0f4557',
      secondary: '#5a7a88',
      disabled: '#99b5b0',
    },
    divider: '#dfe3e8',
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
    h1: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 700,
    },
    h2: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 700,
    },
    h3: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 600,
    },
    h4: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 600,
    },
    h5: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 600,
    },
    h6: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontWeight: 600,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 14,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        *:focus-visible {
          outline: none !important;
          outline-offset: 0 !important;
        }
      `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          padding: '10px 20px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(26, 158, 143, 0.25)',
          },
        },
        contained: {
          '&:hover': {
            transform: 'translateY(-1px)',
          },
        },
        containedPrimary: {
          background: '#1a9e8f',
          '&:hover': {
            background: '#138a7d',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
        },
        elevation1: {
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
        },
        elevation2: {
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
          border: '1px solid #dfe3e8',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '&, & *, & *:focus, & *:focus-visible, & *:focus-within': {
            outline: 'none !important',
          },
          '& .MuiOutlinedInput-root': {
            borderRadius: 14,
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#1a9e8f',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#1a9e8f',
              borderWidth: 2,
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1a9e8f',
          },
          '&.Mui-focused': {
            outline: 'none !important',
            boxShadow: 'none !important',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1a9e8f',
          },
        },
        input: {
          '&:focus': {
            outline: 'none !important',
          },
          '&:focus-visible': {
            outline: 'none !important',
          },
        },
        notchedOutline: {
          borderColor: '#dfe3e8',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        shrink: {
          backgroundColor: 'white',
          paddingLeft: 6,
          paddingRight: 6,
          marginLeft: -4,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#f0f5f4',
            color: '#0f4557',
            fontWeight: 600,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#f8fafa',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #e8edef',
          color: '#0f4557',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 20,
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 600,
          color: '#1a9e8f',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1a9e8f',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          margin: '2px 8px',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.25)',
            },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
        colorPrimary: {
          backgroundColor: '#d6f0ed',
          color: '#0a7b6f',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 14,
        },
        standardSuccess: {
          backgroundColor: '#d4edda',
          color: '#1b7652',
        },
        standardError: {
          backgroundColor: '#ffe6e6',
          color: '#cc3d3d',
        },
        standardWarning: {
          backgroundColor: '#fff3cd',
          color: '#cc9300',
        },
        standardInfo: {
          backgroundColor: '#cce5ff',
          color: '#0069cc',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#0f4557',
          borderRadius: 8,
          fontSize: 12,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 14,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '2px 8px',
          '&:hover': {
            backgroundColor: '#f0f5f4',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          borderRadius: 14,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          '&:hover': {
            backgroundColor: 'rgba(26, 158, 143, 0.08)',
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 12px rgba(26, 158, 143, 0.3)',
        },
        primary: {
          backgroundColor: '#1a9e8f',
          '&:hover': {
            backgroundColor: '#138a7d',
          },
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        colorPrimary: {
          color: '#1a9e8f',
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          backgroundColor: '#e8edef',
        },
        barColorPrimary: {
          backgroundColor: '#1a9e8f',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#1a9e8f',
          height: 3,
          borderRadius: 3,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          '&.Mui-selected': {
            color: '#1a9e8f',
          },
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          '& .MuiPaginationItem-root': {
            borderRadius: 10,
            '&.Mui-selected': {
              backgroundColor: '#1a9e8f',
              color: '#ffffff',
              '&:hover': {
                backgroundColor: '#138a7d',
              },
            },
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          '&.Mui-checked': {
            color: '#1a9e8f',
            '& + .MuiSwitch-track': {
              backgroundColor: '#1a9e8f',
            },
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#dfe3e8',
          '&.Mui-checked': {
            color: '#1a9e8f',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#dfe3e8',
          '&.Mui-checked': {
            color: '#1a9e8f',
          },
        },
      },
    },
  },
});

export default theme;
